// extracted by mini-css-extract-plugin
export default {"form_footer":"form_footer_FGKQa"};